import React from 'react';
import { fechahora, timestampToDate } from '../../../../../../services/utils';

// Filas compactas: menos padding vertical que el default de la tabla
// "striped". El usuario del cambio va sin salto de línea para que quepa en
// una sola fila.
const celdaCompacta = { padding: "3px 10px" };
const celdaSinSalto = { ...celdaCompacta, whiteSpace: "nowrap" };

class ChangesROW extends React.Component {

  handleClick = () => {
  }

  render() {

    var numeroPrev = (this.props.ParticipanDetail.numero == null) ? "No Asignado" : this.props.ParticipanDetail.numero;
    var cantidadCambios = 0;
    var ListaCambios = [];

    for (var e in this.props.ParticipanDetail.changesRegistry) {
      var d = new Date(this.props.ParticipanDetail.changesRegistry[e].date);
      cantidadCambios++;
      ListaCambios.push(<tr key={e}>
        <td style={celdaCompacta}>
          {this.props.ParticipanDetail.changesRegistry[e].description} {" "} - {" "}
          {timestampToDate(this.props.ParticipanDetail.changesRegistry[e].date)}
        </td>
        <td style={celdaSinSalto}>
          {this.props.ParticipanDetail.changesRegistry[e].nombresUser}
          {this.props.ParticipanDetail.changesRegistry[e].apellidosUser}
        </td>
      </tr>);
    }

    return (<tr>
      <td style={celdaCompacta}>{numeroPrev}</td>
      <td style={celdaCompacta}>{this.props.ParticipanDetail.nombres}</td>
      <td style={celdaCompacta}>{this.props.ParticipanDetail.apellidos}</td>
      <td style={celdaCompacta}>{cantidadCambios}</td>
      <td style={celdaCompacta}>
        <table>
          <tbody>
            {ListaCambios}
          </tbody>
        </table>
      </td>
    </tr>
    );
  }
}
export default ChangesROW;